/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CheckApiModel } from './check';
import { TransactionApiModel } from './transaction';
import { ShippingApiModel } from './shipping';
import { OrderProcessingInfoApiModel } from './order-processing-info';
import { OrderFuelDeliveryApiModel } from './order-fuel-delivery';

export interface OrderApiModel {
  /**
   * Is Order cancellation allowed (readonly)
   */
  cancel_allowed?: boolean | null;
  check: CheckApiModel;
  /**
   * Comment
   */
  comment?: string | null;
  /**
   * Created order time
   */
  created?: string | null;
  /**
   * Delivered time
   */
  delivered?: string | null;
  fuel_delivery?: OrderFuelDeliveryApiModel;
  /**
   * Order ID
   */
  id?: string | null;
  /**
   * Loyalty ID
   */
  loyalty_id?: string | null;
  /**
   * Order number
   */
  number?: string | null;
  /**
   * Order paid flag
   */
  paid?: boolean | null;
  /**
   * Order payment method
   */
  payment_method: OrderApiModelPaymentMethodEnum | null;
  /**
   * Pos ID
   */
  pos_id?: string | null;
  processing?: OrderProcessingInfoApiModel;
  shipping?: ShippingApiModel;
  /**
   * Order status
   */
  status?: OrderApiModelStatusEnum | null;
  /**
   * Terminal ID
   */
  terminal_id?: string | null;
  /**
   * Time zone
   */
  time_zone?: string | null;
  /**
   * Order transactions
   */
  transaction?: Array<TransactionApiModel> | null;
  /**
   * Order type
   */
  type?: OrderApiModelTypeEnum | null;
}
export enum OrderApiModelPaymentMethodEnum {
  PaymentAtCheckout = 'payment-at-checkout',
  PaymentUponReceipt = 'payment-upon-receipt'
}
export enum OrderApiModelStatusEnum {
  Created = 'created',
  Inprocess = 'inprocess',
  Delivered = 'delivered',
  Canceled = 'canceled'
}
export enum OrderApiModelTypeEnum {
  OnlineStore = 'online-store',
  FuelTaxi = 'fuel-taxi'
}
